import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ip: window.g.baseURL, //打包时的ip地址
    // token: localStorage.getItem('authorization'),
    activeIndex:true,
    active:-1,
    token:'',  //无效token（这个token没有用到）
    hasLogin: localStorage.getItem("hasLogin")? localStorage.getItem("hasLogin"):"1",   //0为登录 1为登出
    // hasLogin: "0",   //0为登录 1为登出
    isApp:false,
    isLang:'',
    userMsg:false||localStorage.getItem("setUserMsg"),
    userName:''||localStorage.getItem("userName"),
    chip:''||localStorage.getItem("chip"),
    tokenData:''||localStorage.getItem("tokenData"),  //用户Token
    activity:1 //活动 0为close，1为open
  },
  mutations: {
    login(state,provider){  //登录方法
      // console.log('provider',provider)
		  state.hasLogin = "0";
		  state.token = provider.uid;
      state.userName = provider.nickName;
      state.chip = provider.chip;
      localStorage.setItem("token",provider.uid)
      localStorage.setItem("hasLogin","0")
      localStorage.setItem("userName",provider.nickName)
      localStorage.setItem("chip",provider.chip)

	  },
	  logout(state){   //退出登录方法
      state.hasLogin = "1";
		  state.token = ""; //无效token
		  state.userName = "";
		  state.tokenData = ""; //用户Token
      localStorage.setItem("token",'')
      localStorage.setItem("hasLogin","1")
      localStorage.setItem("userName",'')
      localStorage.setItem("tokenData",'')
	  },
    //用户信息展示
    // setUserMsg(state,a){
    //   state.userMsg=a
    //   // localStorage.setItem("userMsg",a)
    // },
    setToken(state,a){ //用户Token
      state.tokenData=a
      localStorage.setItem("tokenData",a)
      // console.log('tokenData----',a)
    },
    setShow(state,a){
      state.activeIndex=a
    },
    setActive(state,a){
      state.active=a
    },
    setIsApp(state,a){   //H5、PC切换
      state.isApp=a
    },
    setLang(state,a){    //语言切换
      state.isLang=a
    },
    setActivity(state,a){
      state.activity=a
    }
  },
  actions: {
  },
  modules: {
  }
})
